import { render, staticRenderFns } from "./OrderStatisticsByDate.vue?vue&type=template&id=25870894&scoped=true&"
import script from "./OrderStatisticsByDate.vue?vue&type=script&lang=js&"
export * from "./OrderStatisticsByDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25870894",
  null
  
)

export default component.exports